<script setup lang="ts">
import TableEmptyText from '@/components/texts/TableEmptyText.vue';

export interface DataItem {
  _id: string;
  num: number;
  type: 'Delivery' | 'Pickup';
  code: string;
  name: string;
  phone: string;
  description: string;
  time: string;
  firstDate: string;
  secondDate: string;
}

export interface Props {
  data?: DataItem[];
}
const props = withDefaults(defineProps<Props>(), {
  data: () => [],
});

const titleData = {
  num: '#',
  type: 'Type',
  code: 'Code',
  name: 'Name',
  phone: 'Phone',
  description: 'Description',
  time: 'Time',
  firstDate: 'First date',
  secondDate: 'Second date',
};

const foldColspan = Object.keys(titleData).length;
</script>

<template>
  <table
    data-testid="specialOptionsConfirmStepNewAirRoadCustomTable"
    :class="$style.specialOptionsConfirmStepNewAirRoadCustomTable"
  >
    <thead>
      <tr>
        <template
          v-for="(titleValue, titleKey, titleIndex) in titleData"
          :key="titleKey"
        >
          <th :class="$style[titleKey + 'Th']">
            {{ titleValue }}
          </th>
        </template>
      </tr>
    </thead>
    <tr v-if="!props.data?.length">
      <td :colspan="foldColspan" class="border-b-0 p-0">
        <TableEmptyText>No AirRoad special options</TableEmptyText>
      </td>
    </tr>
    <tbody v-else>
      <template v-for="(dataItem, dataIndex) in props.data" :key="dataItem._id">
        <tr>
          <template
            v-for="(titleValue, titleKey, titleIndex) in titleData"
            :key="titleKey"
          >
            <td :class="$style[titleKey + 'Td']">
              {{ dataItem[titleKey] }}
            </td>
          </template>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.specialOptionsConfirmStepNewAirRoadCustomTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  text-align: left;

  & > thead > tr,
  & > tbody > tr,
  & > tr {
    & > th {
      font-weight: 500;
      padding: 4px 12px;
      vertical-align: baseline;
    }
    & > td {
      padding: 4px 12px;
      vertical-align: baseline;
    }
    & > th:first-child,
    & > td:first-child {
      padding-left: 0;
    }
    & > th:last-child,
    & > td:last-child {
      padding-right: 0;
    }
  }
}
  .numTh {
  }
  .typeTh {
  }
  .codeTh {
  }
  .nameTh {
  }
  .phoneTh {
  }
  .descriptionTh {
  }
  .timeTh {
  }
  .firstDateTh {
  }
  .secondDateTh {
  }
  .numTd {
  }
  .typeTd {
  }
  .codeTd {
  }
  .nameTd {
  }
  .phoneTd {
  }
  .descriptionTd {
  }
  .timeTd {
  }
  .firstDateTd {
  }
  .secondDateTd {
  }
</style>
